import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils.ts";
import { Icon, type IconName } from "@repo/ui/icon";
import { ActionLink } from "@/components/common/actions/actions.component";
import { getI18nString } from "@/lib/utils";
import { getIconColorStyle, getIconTintStyle } from "@/lib/design-colors";
import type { DesignColorValue } from "@/lib/design-colors";
import type { MenuItem } from "@/components/navigation/navigation.types";
interface MenuItemLinkProps {
  item: MenuItem;
  colour?: DesignColorValue | null;
  iconSize?: "md" | "lg";
}
export function MenuItemLink(t0) {
  const $ = _c(14);
  const {
    item,
    colour,
    iconSize: t1
  } = t0;
  const iconSize = t1 === undefined ? "lg" : t1;
  if (!item.action?.to) {
    return null;
  }
  const t2 = item.action.to;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("group flex items-center gap-3");
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== colour || $[2] !== iconSize || $[3] !== item.icon) {
    t4 = item.icon && <span className={cn("flex flex-shrink-0 items-center justify-center rounded-full", iconSize === "md" ? "h-10 w-10" : "p-3", !colour && "bg-deep-sea-blue-50")} style={getIconTintStyle(colour)}><Icon name={item.icon as IconName} size={iconSize} className={cn(!colour && "text-text-primary")} style={getIconColorStyle(colour)} /></span>;
    $[1] = colour;
    $[2] = iconSize;
    $[3] = item.icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("typography-component-sm-medium text-text-primary", "border-b border-transparent transition-colors tablet:group-hover:border-text-primary");
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== item.action.text) {
    t6 = getI18nString(item.action.text, "Link");
    $[6] = item.action.text;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <span className={t5}>{t6}</span>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== item.action.to || $[11] !== t4 || $[12] !== t7) {
    t8 = <ActionLink actionTo={t2} className={t3}>{t4}{t7}</ActionLink>;
    $[10] = item.action.to;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}